import React, { useRef, useState } from 'react';
import { Box, Button, useWindowSize } from '@miro-site/core';
import { Input } from '@miro-site/form-controls';
import styled, { css } from 'styled-components';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
//#region DEFAULT STYLES ----
var defaultWrapperStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  marginTop: [24, 32],
  '> div:first-child': {
    flexGrow: 1
  }
};
var defaultInputStyles = {
  borderRadius: 32,
  paddingLeft: 24
}; //#endregion DEFAULT STYLES ----
//#region overridng inputstyles to match with ui for experimentaion

var BoxContainer = styled(Box).withConfig({
  displayName: "ButtonWithInput__BoxContainer",
  componentId: "sc-197kghn-0"
})(["input{width:calc(100% - 12px);}", " .cta-input-field{", ";}"], function (_ref) {
  var $isStackedView = _ref.$isStackedView;
  return $isStackedView && css(["display:flex;flex-direction:column;> *{width:100%;}a{text-align:center;margin-top:10px;line-height:1.5;border-radius:32px;}input{width:100%;}"]);
}, function (_ref2) {
  var theme = _ref2.theme;
  return css(["", ""], theme.mq.large(css(["height:50px;padding-right:24px;font-size:18px;"])));
}); //#endregion

var ButtonWithInput = function ButtonWithInput(props) {
  var $styles = props.$styles,
      $withArrow = props.$withArrow,
      $wrapperStyles = props.$wrapperStyles,
      $inputStyles = props.$inputStyles,
      testId = props.testId,
      className = props.className,
      href = props.href,
      inputCTA = props.inputCTA,
      children = props.children,
      templateId = props.templateId,
      $buttonType = props.$buttonType;
  var inputRefContainer = useRef();

  var _useState = useState(''),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var isMobile = width && width <= theme.breakpoints.v2Mobile;

  var checkAndValidateTheRegex = function checkAndValidateTheRegex(inputCTA, value) {
    var DEFAULT_REGEX = {
      EMAIL: /^([a-z0-9_\-]+[\.\+])*[a-z0-9_\-]+@([a-z0-9][a-z0-9\-]*\.)+[a-z]{2,}$/i //eslint-disable-line

    };
    var currentRegex;

    if (inputCTA.regex) {
      currentRegex = new RegExp(inputCTA.regex);
    } else if (inputCTA.type.toUpperCase() === 'EMAIL') {
      currentRegex = DEFAULT_REGEX.EMAIL;
    }

    if (currentRegex) {
      return !currentRegex.test(value) ? inputCTA.errorMessage : '';
    }

    return '';
  };

  var onButtonClick = function onButtonClick(e) {
    e.preventDefault();
    handleValidationAndRedirect();
  };

  var onInputKeyDown = function onInputKeyDown(e) {
    if (e.key === 'Enter') {
      handleValidationAndRedirect();
    }
  };

  var handleValidationAndRedirect = function handleValidationAndRedirect() {
    var valueOfInput = inputRefContainer.current.value; //if no value then user didnt enter anything so just redirecting

    if (!valueOfInput) {
      window.location.href = href;
      return;
    }

    var errorMessage = checkAndValidateTheRegex(inputCTA, valueOfInput);

    if (errorMessage) {
      return setErrorMessage(errorMessage);
    }

    var param = inputCTA.queryParamKey + '=' + valueOfInput;
    var seperator = '&';

    if (href.indexOf('?') === -1) {
      seperator = '?';
    }

    window.location.href = href + seperator + param;
  };

  return /*#__PURE__*/_jsxs(BoxContainer, {
    $styles: $wrapperStyles || defaultWrapperStyles,
    $isStackedView: inputCTA.stackedView || isMobile,
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx(Input, {
      type: inputCTA.type || 'text',
      ref: inputRefContainer,
      name: 'input-cta-' + inputCTA.type,
      style: $inputStyles || defaultInputStyles,
      placeholder: inputCTA.placeholder,
      isError: !!errorMessage,
      error: errorMessage,
      onKeyDown: onInputKeyDown,
      className: "cta-input-field"
    }), /*#__PURE__*/_jsx(Button, {
      $styles: $styles,
      className: className,
      $withArrow: $withArrow,
      $buttonType: $buttonType,
      $size: "medium",
      href: href,
      templateId: templateId,
      onClick: onButtonClick,
      children: children
    })]
  });
};

export default ButtonWithInput;